import { setSelectedItems } from "../../vendor/src/features/remotion-editor/editor/state/actions/set-selected-items";
import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "../../vendor/ds-react";
import { PlayerRefContext } from "../../vendor/src/features/remotion-editor/editor/context-provider";
import {
  useCurrentStateAsRef,
  useWriteContext,
} from "../../vendor/src/features/remotion-editor/editor/utils/use-context";
import { currentFrameDraft, imageCutDraft } from "../../protocol/current-frame-draft";
import type { VideoDraftInput } from "../../protocol/video-draft";
import { connectFrameVideoPicker } from "../host/frame-video-picker";
import { NativeVideoDraftDialog } from "./NativeVideoDraftDialog";
import { hasPendingTimelineEdit } from "./edit-ownership";
import { editorUserMessage } from "../../protocol/user-message";

export function FrameVideoTools({ disabled }: { disabled: boolean }) {
  const player = useContext(PlayerRefContext),
    current = useCurrentStateAsRef(),
    { setState } = useWriteContext();
  const [draft, setDraft] = useState<VideoDraftInput | null>(null);
  const openRef = useRef<(id: string) => void>(() => {});
  openRef.current = (id) => {
    try {
      if (disabled || hasPendingTimelineEdit(current.current))
        throw Error("저장이나 이동을 마친 뒤 다시 시도해 주세요.");
      const document = current.current.undoableState;
      const frame = player?.current?.getCurrentFrame();
      const input = document.items[id]?.type === "image"
        ? imageCutDraft(document, id)
        : currentFrameDraft(document, id, frame ?? -1);
      setState({
        commitToUndoStack: false,
        update: (prev) => setSelectedItems(prev, [id]),
      });
      player?.current?.pause();
      setDraft(input);
    } catch (error) {
      toast({
        type: "error",
        description: editorUserMessage(error),
        toastOptions: { position: "top-center" },
      });
    }
  };
  useEffect(() => connectFrameVideoPicker((id) => openRef.current(id)), []);
  return draft && player ? (
    <NativeVideoDraftDialog
      open
      initialDraft={draft}
      playerRef={player}
      onClose={() => setDraft(null)}
    />
  ) : null;
}
